import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Sobre', href: '#about' },
  { label: 'Serviços', href: '#services' },
  { label: 'Portfólio', href: '#portfolio' },
  { label: 'Contato', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-brand-bg/95 backdrop-blur-md border-b border-brand-border' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" onClick={() => handleNavClick('#home')} className="cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/d19cdf12-b626-4056-8bec-014908ede6b4/4b3383be-caac-42d7-b117-f2826773f1dd_LOGO-MRC-TI_VERDE-SEM-FUNDO.png?v=5802c3902a68e1c369d6e569dd6c5551"
            alt="MRC TI Logo"
            className="h-[140px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNavClick(link.href)}
                className="text-sm font-medium text-gray-300 hover:text-neon-green transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA Button Desktop */}
        <a
          href="#contact"
          onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
          className="hidden md:inline-flex items-center gap-2 bg-neon-green text-black text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-green-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          Fale Conosco
        </a>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white p-2 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-brand-bg/98 border-t border-brand-border px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-sm font-medium text-gray-300 hover:text-neon-green transition-colors text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
            className="inline-flex items-center justify-center bg-neon-green text-black text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-green-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            Fale Conosco
          </a>
        </div>
      )}
    </nav>
  );
}
